import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import Button from "../atoms/button"
import { Spacer } from "../atoms/layout-primitives"
import { BlogGrid } from "../atoms/layout-primitives/grid"
import ExploreButtons from "../molecules/explore-buttons"
import { IContentfulTag } from "../types/blog.types"
import InternalRoutes from "../util/internal-routes"

interface IExploreCategoriesProps {
  categories: IContentfulTag[]
}

/**
 * Template for "Explore Categories" section
 * @param categories - list of categories
 */
const ExploreCategories = ({ categories }: IExploreCategoriesProps) => {
  const { backgroundImage } = useStaticQuery(graphql`
    query {
      backgroundImage: file(
        relativePath: { eq: "6_BLOG/categories/explore_categories.jpeg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1154) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <BlogGrid noPadding={{ sm: true, md: true }}>
      <ExploreButtons
        title={"See Posts by Category"}
        background={backgroundImage.childImageSharp.fluid}
      >
        {categories.map((category) => (
          <Button.Link to={InternalRoutes.Blog(category)} key={category.slug}>
            {category.name}
          </Button.Link>
        ))}
      </ExploreButtons>
      <Spacer height={{ sm: "8px", md: "16px", lg: "48px" }} />
    </BlogGrid>
  )
}

export default ExploreCategories
